import { APIServiceType } from '@/api/types';
import { DdEventCategory, DdEventType } from '../logger/datadog/types';

export enum ErrorType {
  API = 'api',
  SESSION = 'session',
  CLIENT = 'client',
  PARSE = 'parse',
  GEOLOCATION = 'geolocation',
  DEFAULT = 'default',
  GAME = 'game',
}

export type DefaultErrorPayload = {
  message: string;
  reason: string;
  name?: string;
};

export type APIError = {
  type: ErrorType.API;
  payload: DefaultErrorPayload & {
    service: APIServiceType;
  };
};

export type SessionError = {
  type: ErrorType.SESSION;
  payload: DefaultErrorPayload;
  details?: unknown;
};

export type ClientError = {
  type: ErrorType.CLIENT;
  payload: DefaultErrorPayload;
};

export type ParseError = {
  type: ErrorType.PARSE;
  payload: DefaultErrorPayload;
  details?: unknown;
};

export type DefaultError = {
  type: ErrorType.DEFAULT;
  payload: ErrorPayload;
  details?: unknown;
};

export type GeolocationHandlerError = {
  type: ErrorType.GEOLOCATION;
  payload: DefaultErrorPayload;
  details?: unknown;
};

export type HandleErrorParams =
  | APIError
  | SessionError
  | ClientError
  | ParseError
  | GeolocationHandlerError
  | DefaultError;

export type ErrorPayload = DefaultErrorPayload &
  Record<string, unknown> & {
    type?: string;
    errorCode?: number;
    details?: Record<string, unknown>;
    service?: APIServiceType;
  };

export interface ErrorHandlerOptions {
  useCase?: DdEventCategory;
  eventType?: DdEventType;
  service?: string;
  stack?: string;
  context?: Record<string, unknown>;
  skipLogging?: boolean;
}
